<template>
  <div class="grab-hall-page">
    <div class="page-header">
      <div class="header-left">
        <el-button type="text" icon="el-icon-arrow-left" @click="$router.back()" />
        <h1>🎯 {{ $t('driverHome.grabHall') }}</h1>
      </div>
    </div>
    <div class="task-list">
      <div v-if="loading" class="loading-state"><p>{{ $t('common.loading') }}</p></div>
      <div v-else-if="tasks.length === 0" class="empty-state"><p>{{ $t('driverHome.noAvailableTasks') }}</p></div>
      <div v-else>
        <div v-for="task in tasks" :key="task.id" class="task-card">
          <div class="task-header">
            <div class="task-no">{{ task.taskNo }}</div>
            <div class="task-fee">¥{{ task.fee || 0 }}</div>
          </div>
          <div class="task-body">
            <div>📍 {{ task.pickupAddress || $t('driverHome.warehouse') }}</div>
            <div>🏠 {{ task.deliveryAddress }}</div>
          </div>
          <el-button type="primary" size="small" @click="grabTask(task)">🎯 {{ $t('driverHome.grabNow') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAvailableContractorTasks, grabTask } from '@/api/delivery'

export default {
  name: 'GrabHall',
  data() {
    return {
      loading: false,
      tasks: []
    }
  },
  created() {
    this.loadTasks()
  },
  methods: {
    async loadTasks() {
      this.loading = true
      try {
        const res = await getAvailableContractorTasks({ page: 0, size: 20 })
        this.tasks = res.content || res.data?.content || []
      } catch (error) {
        this.$message.error(this.$t('driverHome.loadFailed'));
      } finally {
        this.loading = false
      }
    },
    async grabTask(task) {
      const driverId = localStorage.getItem('driver_id')
      try {
        await grabTask(task.id, Number(driverId))
        this.$message.success(this.$t('driverHome.grabSuccess'));
        this.loadTasks()
      } catch (error) {
        this.$message.error(this.$t('driverHome.grabFailed'));
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.grab-hall-page {
  min-height: 100vh;
  background: #f5f7fa;
  .page-header {
    padding: calc(16px + env(safe-area-inset-top, 0px)) 20px;
    background: white;
    h1 { font-size: 18px; margin: 0; }
  }
  .task-list { padding: 20px; }
  .task-card {
    background: white;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 12px;
    .task-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      .task-fee { color: #ff6b35; font-weight: bold; }
    }
  }
  .loading-state, .empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #999;
  }
}

// 移动端优化
@media (max-width: 768px) {
  .grab-hall-page {
    padding: 0;
  }
  
  .page-header {
    padding: 12px 15px !important;
    
    h1 {
      font-size: 16px !important;
    }
  }
  
  .task-list {
    padding: 15px !important;
    
    .task-card {
      padding: 12px !important;
      margin-bottom: 10px !important;
      
      .task-header {
        margin-bottom: 10px !important;
        
        .task-fee {
          font-size: 16px !important;
        }
      }
    }
    
    .el-button {
      width: 100% !important;
    }
  }
}
</style>
